import React, { Component } from 'react';
import { Stack, List, ListItem, Divider, Typography, TextField, Button, FormControl, InputLabel, Select, MenuItem, Skeleton, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { connect } from 'react-redux';
import StepOne from './images/dia1.png';
import StepTwo from './images/dia2.png';
import StepThree from './images/dia3.png';
import StepFour from './images/dia4.png';
import StepFive from './images/dia5.png';
import StepSix from './images/dia6.png';
import StepSeven from './images/dia7.png';
import StepEight from './images/dia8.png';
import StepNine from './images/dia9.png';
import StepTen from './images/dia10.png';
import StepEleven from './images/dia11.png';
import StepTwelve from './images/dia12.png';
import StepThirteen from './images/dia13.png';
import StepFourteen from './images/dia14.png';
import servAccount1 from './images/servAccount1.png';
import servAccount2 from './images/servAccount2.png';
import servAccount3 from './images/servAccount3.png';
import KeyIcon from '@mui/icons-material/Key';
import { toWapi, post } from '../../util/api';

class dialogflow extends Component {
	state = {
		copiedPid: false,
		copiedToken: false,
		phoneIds: [],
    	selectedPhoneId: '',
		isActive: false,
	};
	
	componentDidMount() {
		this.listPhones();
	}

	async listPhones() {
		const { product } = this.props;
		const pid = product.id;
		const token = product.settings.wapi_token;
	  
		try {
		  const response = await toWapi(`/api/${pid}/listPhones`, token);
		  const phoneData = response.data;
	  
		  if (Array.isArray(phoneData)) {
			const ids = phoneData.map(phone => phone.id);
			this.setState({ phoneIds: ids });
		  } else {
			console.error('Hata: Geçersiz API yanıtı');
		  }
		} catch (error) {
		  console.error('Hata:', error);
		}
	}
	
	async getIntegration() {
		let { product } = this.props;
		let pid = product.id;
		let { selectedPhoneId } = this.state;
	
		await post('/dialogflow/getIntegration', { pid, selectedPhone: selectedPhoneId }).then((data) => {
			let result = data.data;
			let integrations = result.integrations;
	
			if (integrations && integrations.id) {
				this.setState({
					project_id: integrations.shop,
					selectedFile: integrations.data.file_name,
					languageCode: integrations.data.languageCode,
					credentialss: JSON.stringify(integrations.data.credentials, null, 2)
				});
			} else {
				this.setState({
					project_id: null,
					selectedFile: null,
					languageCode: null,
				});
			}
			this.setState({ integrations });
		});
	}
	async insertIntegration() {
		this.setState({ showSkeleton: true})
		let { fileContent, languageCode, project_id, selectedFile, integrations, selectedPhoneId } = this.state;
		const response = await post('/dialogflow/upsertIntegration', {
			project_id,
			languageCode,
			credentials: fileContent || this.state.credentialss,
			file_name: selectedFile,
			id: integrations && integrations.id,
			phone_id:selectedPhoneId
		});
		if (response.status === 200) {
			this.setState({ settingsSavedSuccessfully: true, showSkeleton: false });
			this.handleTimeout();
			setTimeout(() => {
                window.location.reload();
            }, 2000);
		}
	}
	handleTimeout = () => {
		setTimeout(() => {
			this.setState({ settingsSavedSuccessfully: false });
		}, 5000);
	};
	handleButtonClick = () => {
		this.setState((prevState) => ({ isActive: !prevState.isActive }));
	};
	handleFileChange = (event) => {
		const file = event.target.files[0];
		console.log('file', file);
		const reader = new FileReader();

		reader.onload = (e) => {
			const content = e.target.result;
			console.log('content', content);
			this.setState({ fileContent: content, selectedFile: file.name });
		};

		reader.readAsText(file);
	};

	handlePhoneChange = (event) => {
		const selectedPhoneId = event.target.value;
		this.setState({ selectedPhoneId }, () => {
			this.getIntegration();
		});
	};

	render() {
		let { project_id, selectedFile, languageCode, phoneIds, selectedPhoneId } = this.state;
		return (
				<Stack spacing={2} sx={{ marginBottom: '10px', padding: '8px' }}>
					<List>
						<Divider sx={{ fontSize: '17px' }} textAlign="left">
							<KeyIcon /> Dialogflow
						</Divider><br/>
						<FormControl fullWidth>
							<InputLabel id="demo-simple-select-label">Choose Active Phone</InputLabel>
							<Select
								labelId="demo-simple-select-label"
								id="demo-simple-select"
								value={selectedPhoneId}
								label="Choose Active Phone"
								onChange={this.handlePhoneChange}
							>
								{phoneIds.map((phoneId) => (
									<MenuItem key={phoneId} value={phoneId}>
										{phoneId}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					{selectedPhoneId && (
						<form style={{ textAlign: 'left' }}>
							<TextField
								fullWidth
								margin="normal"
								label="Project Id"
								value={project_id ? project_id : ''}
								type="text"
								defaultValue={project_id}
								onChange={({ target: { value } }) => this.setState({ project_id: value })}
							></TextField>
							<TextField
								fullWidth
								margin="normal"
								label="Language Code"
								value={languageCode ? languageCode : ''}
								type="text"
								defaultValue={languageCode}
								onChange={({ target: { value } }) => this.setState({ languageCode: value })}
							></TextField>
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<TextField
									fullWidth
									label="JSON File"
									margin="normal"
									value={selectedFile ? selectedFile : ''}
									InputProps={{
										readOnly: true,
										endAdornment: (
											<label htmlFor="contained-button-file">
												<Button variant="contained" component="span">
													Import
												</Button>
											</label>
										),
									}}
								/>
								<input accept=".json" id="contained-button-file" type="file" style={{ display: 'none' }} onChange={this.handleFileChange} />
							</div>
							<Button disabled={!selectedFile || !languageCode || !project_id || !selectedPhoneId} variant="contained" component="span" onClick={() => this.insertIntegration()}>
								Save
							</Button>
							<Button
								style={{ backgroundColor: this.state.isActive ? 'green' : 'red', float:'right'}}
								variant="contained"
								component="span"
								onClick={this.handleButtonClick}
								>
								{this.state.isActive ? 'Active' : 'Passive'}
							</Button>
							{this.state.showSkeleton && (
										<Box sx={{ width: '30%', margin: "auto" }}>
											<Skeleton animation="wave" />
											<Skeleton animation="wave" />
											<Skeleton animation="wave" />
										</Box>
									)}
									{this.state.settingsSavedSuccessfully && (
										<div style={{margin:'auto', textAlign:"center"}}>
											<p>
												<CheckCircleIcon style={{ fontSize: 80, color: 'green' }} /><br/>
												Your Dialogflow settings were saved successfully<br/>
												Page is reloading
											</p>
										</div>
									)}
						</form>
						)}
					</List>
					<h2 style={{ textAlign: 'center' }}>Dialogflow Documentation</h2>
                    <Typography variant="h5" gutterBottom style={{ textAlign: 'left', color:"orange" }} >
                    Enable the Dialogflow API
					</Typography>
                    <p style={{fontSize:"15px"}}>You can activate the Dialogflow API feature for your agent within Dialogflow cloud page. <br/>Follow these steps:</p>
					<List style={{ textAlign: 'left' }}>
						<ListItem style={{ marginBottom: '10px', display: 'block' }}>
							<h3>1. Click the Gear icon next to the agent name from the top left of the Dialogflow dashboard.</h3>
                            <div style={{ display: 'flex' }}>
								<img
									src={StepOne}
									alt="dialogflow_1"
									style={{
										width: '48%',
										marginRight: '5px',
										boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.18)',
										marginTop: '20px',
										cursor: 'pointer',
									}}
								/>
							</div>
						</ListItem>
						<ListItem style={{ marginBottom: '10px', display: 'block' }}>
							<h3>2. The General Settings page is displayed. From there scroll down, to note the project ID value.</h3>
							<div style={{ display: 'flex' }}>
								<img
									src={StepTwo}
									alt="dialogflow_2"
									style={{
										width: '48%',
										marginRight: '5px',
										boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.18)',
										marginTop: '20px',
										cursor: 'pointer',
									}}
								/>
							</div>
						</ListItem>
						<ListItem style={{ marginBottom: '10px', display: 'block' }}>
							<h3>3. Click on the project ID to open google cloud.</h3>
							<h3>4. You will navigate to the Google Cloud dashboard.</h3>
							<h3>5. Select APIs & Services → Enabled APIs & Services from the left resources menu.</h3>
							<h3>6. Click + Enable APIs and Services from the top of the display and find the Dialogflow API option.</h3>
							<div>
								<img
									src={StepThree}
									alt="dialogflow_3"
									style={{ width: '48%', boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.18)', marginTop: '20px', cursor: 'pointer' }}
								/><br/>
                                <img
									src={StepFour}
									alt="dialogflow_4"
									style={{ width: '48%', boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.18)', marginTop: '20px', cursor: 'pointer'}}
								/>
							</div>
						</ListItem>
                        <ListItem style={{ marginBottom: '10px', display: 'block' }}>
							<h3>7. Upon activation of Dialogflow API, select Manage to open the Dialogflow API management dashboard.</h3>
							<div style={{ display: 'flex' }}>
								<img
									src={StepFive}
									alt="dialogflow_5"
									style={{
										width: '48%',
										marginRight: '5px',
										boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.18)',
										marginTop: '20px',
										cursor: 'pointer',
									}}
								/>
							</div>
						</ListItem>
                        <Typography variant="h5" gutterBottom style={{ textAlign: 'left', color:"orange" }} >
                            Create Service Account Credentials
					    </Typography>
                        <p style={{fontSize:"15px"}}>The next step on the Dialogflow API management dashboard is to create a set of credentials to use the API, and to connect to the<br/>Dialogflow cloud from the Kore.ai platform.</p>
                        <p><span style={{fontWeight:"bold", fontSize:"16px"}}>Service Account Creation</span> <br/>Follow these steps to create service account:</p>
                        <ListItem style={{ marginBottom: '10px', display: 'block' }}>
							<h3>1. Click the button Create Credentials at the top of the screen.</h3>
							<div style={{ display: 'flex' }}>
								<img
									src={StepSix}
									alt="dialogflow_6"
									style={{
										width: '48%',
										marginRight: '5px',
										boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.18)',
										marginTop: '20px',
										cursor: 'pointer',
									}}
								/>
							</div>
						</ListItem>
                        <ListItem style={{ marginBottom: '10px', display: 'block' }}>
							<h3>2. In the Create Credentials page, the Dialogflow API is by default selected in the Select an API drop-down.</h3>
							<div style={{ display: 'flex' }}>
								<img
									src={servAccount1}
									alt="dialogflow_7"
									style={{
										width: '48%',
										marginRight: '5px',
										boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.18)',
										marginTop: '20px',
										cursor: 'pointer',
									}}
								/>
							</div>
						</ListItem>
                        <ListItem style={{ marginBottom: '10px', display: 'block' }}>
							<h3>3. Select Application Data option for What data will you be accessing? as you are creating a service account. Click Next.</h3>
							<div style={{ display: 'flex' }}>
								<img
									src={servAccount2}
									alt="dialogflow_8"
									style={{
										width: '48%',
										marginRight: '5px',
										boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.18)',
										marginTop: '20px',
										cursor: 'pointer',
									}}
								/>
							</div>
						</ListItem>
                        <ListItem style={{ marginBottom: '10px', display: 'block' }}>
							<h3>4. Select No. I’m not using them and click Next.</h3>
							<div style={{ display: 'flex' }}>
								<img
									src={servAccount3}
									alt="dialogflow_9"
									style={{
										width: '48%',
										marginRight: '5px',
										boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.18)',
										marginTop: '20px',
										cursor: 'pointer',
									}}
								/>
							</div>
						</ListItem>
                        <ListItem style={{ marginBottom: '10px', display: 'block' }}>
							<h3>5. In the Service account details page, provide details for service account name, ID and description as shown below.</h3>
							<div style={{ display: 'flex' }}>
								<img
									src={StepSeven}
									alt="dialogflow_10"
									style={{
										width: '48%',
										marginRight: '5px',
										boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.18)',
										marginTop: '20px',
										cursor: 'pointer',
									}}
								/>
							</div>
						</ListItem>
                        <ListItem style={{ marginBottom: '10px', display: 'block' }}>
							<h3>6. Click Create and Continue. The service account is created.</h3>
							<h3>7. Grant access permissions to this service account and provide access to users if needed.</h3>
							<div>
								<img
									src={StepEight}
									alt="dialogflow_11"
									style={{
										width: '48%',
										marginRight: '5px',
										boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.18)',
										marginTop: '20px',
										cursor: 'pointer',
									}}
								/><br/>
                                <img
									src={StepNine}
									alt="dialogflow_12"
									style={{
										width: '48%',
										marginRight: '5px',
										boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.18)',
										marginTop: '20px',
										cursor: 'pointer'
									}}
								/>
							</div>
						</ListItem>
                        <p><span style={{fontWeight:"bold", fontSize:"16px"}}>Private Key Generation</span> <br/>Follow these steps to generate the private key:</p>
                        <ListItem style={{ marginBottom: '10px', display: 'block' }}>
							<h3>1. Click on the service account created under Service Accounts in the API & Services page as shown below.</h3>	
							<div style={{ display: 'flex' }}>
								<img
									src={StepTen}
									alt="dialogflow_13"
									style={{
										width: '48%',
										marginRight: '5px',
										boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.18)',
										marginTop: '20px',
										cursor: 'pointer',
									}}
								/>
							</div>
						</ListItem>
                        <ListItem style={{ marginBottom: '10px', display: 'block' }}>
						    <h3>2. The service account details are displayed as shown in the following screenshot. Go to the Keys tab.</h3>
							<div style={{ display: 'flex' }}>
								<img
									src={StepEleven}
									alt="dialogflow_14"
									style={{
										width: '48%',
										marginRight: '5px',
										boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.18)',
										marginTop: '20px',
										cursor: 'pointer',
									}}
								/>
							</div>
						</ListItem>
                        <ListItem style={{ marginBottom: '10px', display: 'block' }}>
							<h3>3. Select Create a new key in the Add Key drop-down to generate the private key.</h3>
							<div style={{ display: 'flex' }}>
								<img
									src={StepTwelve}
									alt="dialogflow_15"
									style={{
										width:'48%',
										marginRight: '5px',
										boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.18)',
										marginTop: '20px',
										cursor: 'pointer',
									}}
								/>
							</div>
						</ListItem>
                        <ListItem style={{ marginBottom: '10px', display: 'block' }}>
							<h3>4. In the displayed pop-up, select JSON as the option to generate the private key.</h3>
							<div style={{ display: 'flex' }}>
								<img
									src={StepThirteen}
									alt="dialogflow_16"
									style={{
										width: '48%',
										marginRight: '5px',
										boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.18)',
										marginTop: '20px',
										cursor: 'pointer',
									}}
								/>
							</div>
						</ListItem>
                        <p>A file containing the JSON Private Key information for use in the External NLU settings of Kore.ai platform, is downloaded and saved to your computer.</p>
                        <div style={{ display: 'flex' }}>
								<img
									src={StepFourteen}
									alt="dialogflow_16"
									style={{
										width: '50%',
										marginRight: '20px',
										boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.18)',
										marginTop: '20px',
										cursor: 'pointer',
									}}
								/>
							</div>
					</List>
				</Stack>
		);
	}
}
export default connect((state) => ({ user: state.access.user.loggedUserObj, product: state.product.maytapi }))(dialogflow);
